import React, { useState, useEffect, useRef } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../commonButton";
import { formatMomentDate } from "../../../utils/dateHelper";
import withModal from "../../withModal";
import { useToast } from "../../../context/TostContext";
import { Delete02Icon } from "../../../assets/icons";
import InputField from "../../form/InputField";

const CertificationModal = ({ onClose, onSubmit, certification, isLoading }) => {
  const [formData, setFormData] = useState({
    title: "",
    provider: "",
    issued_date: "",
  });
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [removeFile, setRemoveFile] = useState(false);
  const fileInputRef = useRef(null);
  const toast=useToast();
  useEffect(() => {
    if (certification) {
      setFormData({
        title: certification.title || "",
        provider: certification.provider || "",
        issued_date: certification.issued_date ? formatMomentDate(certification.issued_date, "YYYY-MM-DD") : "",
      });
      setFile(null);
      setFilePreview(certification.file?.url || null);
      setRemoveFile(false);
    } else {
      setFormData({
        title: "",
        provider: "",
        issued_date: "",
      });
      setFile(null);
      setFilePreview(null);
      setRemoveFile(false);
    }
  }, [certification]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 5 * 1024 * 1024) {
        toast.error("File size should be less than 5MB");
        return;
      }
      setFile(selectedFile);
      setFilePreview(URL.createObjectURL(selectedFile));
      setRemoveFile(false);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFilePreview(null);
    setRemoveFile(true);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!formData.title) {
      toast.error("Please enter a title");
      return;
    }
    if (!formData.provider) {
      toast.error("Please enter the issuing organization");
      return;
    }
    if (!formData.issued_date) {
      toast.error("Please select an issue date");
      return;
    }

    const todayStr = new Date().toLocaleDateString('en-CA');
    if (formData.issued_date && formData.issued_date > todayStr) {
      toast.error("Issue date cannot be in the future");
      return;
    }

    const submitData = new FormData();
    submitData.append("title", formData.title);
    submitData.append("provider", formData.provider);
    if (formData.issued_date) {
      submitData.append("issued_date", formData.issued_date);
    }

    if (file) {
      submitData.append("file", file);
    } else if (removeFile) {
      submitData.append("remove_file", "true");
    }

    onSubmit(submitData);
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Modal.Body className="grid row-gap-3">
      
        
            <InputField
              label={{ name: "Name" }}
              required
              className="g-col-md-12"
              input={{
                type: "text",
                name: "title",
                value: formData.title,
                onChange: handleChange,
                placeholder: "Ex: AWS Certified Solutions Architect",
              }}
            />
        
         
            <InputField
              label={{ name: "Issuing Company" }}
              required
              className="g-col-md-12"
              input={{
                type: "text",
                name: "provider",
                value: formData.provider,
                onChange: handleChange,
                placeholder: "Ex: Amazon Web Services (AWS)",
              }}
            />
         
          
            <InputField
              label={{ name: "Issue Date" }}
              required
              className="g-col-md-6"
              input={{
                type: "date",
                name: "issued_date",
                value: formData.issued_date,
                onChange: handleChange,
                max: new Date().toLocaleDateString('en-CA'),
              }}
            />
          
          <div className="g-col-md-12">
            <Form.Label>Certificate / Image</Form.Label>
            <div className="d-flex align-items-center gap-3">
              <div
                className="award-file-upload border rounded-2 d-flex align-items-center justify-content-center cursor-pointer overflow-hidden position-relative"
                style={{ width: "100px", height: "100px", backgroundColor: "#f8f9fa" }}
                onClick={() => fileInputRef.current?.click()}
              >
                {filePreview ? (
                  <>
                    <img src={filePreview} alt="Certification Preview" className="w-100 h-100 object-fit-cover" />
                    <button
                      type="button"
                      className="position-absolute top-0 end-0 bg-danger text-white border-0 p-1 d-flex align-items-center justify-content-center"
                      style={{ borderBottomLeftRadius: "4px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveFile();
                      }}
                    >
                      <Delete02Icon width={14} height={14} color="#FFFFFF" />
                    </button>
                  </>
                ) : (
                  <span className="text-muted small">Upload</span>
                )}
              </div>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept="image/*"
                className="d-none"
              />
            </div>
          </div>
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          type="button"
          variant="outline"
          title="Cancel"
          onClick={onClose}
          disabled={isLoading}
        />
        <CommonButton
          type="submit"
          variant="primary"
          title={certification ? "Update" : "Save"}
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Form>
  );
};

export default withModal(CertificationModal);
